import React from 'react';
import { MessageDescriptor } from 'react-intl';

import { ButtonModel } from '@notino/react-styleguide-v20';

import { StyledVoucherInput } from '@sharedComponents/Benefits';
import { CypressTestNamespace } from '@utils/test';

import { messages } from '../messages';

export const BodyColumn =
  (
    validationErrors: string,
    loading: boolean,
    formatMessage: (message: MessageDescriptor) => string,
    validationCallback: (voucherCode: string) => void,
    copiedProductVoucherCode: string,
    resetVoucherCode: () => void,
  ) =>
  () => (
    <StyledVoucherInput
      label={formatMessage(messages.voucherInputLabelText)}
      inputGroupProps={{
        required: false,
        help: '',
        error: validationErrors,
        placeHolder: formatMessage(messages.voucherInputPlaceHolderText),
        'data-testid': CypressTestNamespace.ECartPageCoupons.COUPON_INPUT,
        clearAfterSubmit: true,
        value: copiedProductVoucherCode,
        resetVoucherCode: resetVoucherCode,
      }}
      actionButtonProps={{
        buttonSize: ButtonModel.Sizes.default,
        buttonText: 'OK',
        buttonStyle: ButtonModel.Styles.secondary,
        loading: loading,
        onClick: validationCallback,
        'data-testid': CypressTestNamespace.ECartPageCoupons.COUPON_SUBMIT_BUTTON,
      }}
    />
  );
